var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"blockquote container container--a"},[_c('div',{staticClass:"html-content"},[_c('blockquote',{attrs:{"author":_vm.data.author}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.description)}}),(_vm.data.author)?_c('em',{domProps:{"innerHTML":_vm._s(_vm.data.author)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }